import React from "react";
import { PlateAddress } from "../../../Model/PlateAddress";
import { useTypedSelector } from "../../../redux/reducers/RootReducer";
import {
  getModuleById,
  getModulesByType,
} from "../../../redux/reducers/ModuleReducer";
import {
  getModuleState,
  getModuleStateById,
} from "../../../redux/reducers/ModuleStateReducer";
import { EModuleType } from "../../../Model/EModuleType";
import DateUtil from "../../../Utility/DateUtil";

type PlateIntoRowProps = { title: string; value: string };

const PlateInfoRow = ({ title, value }: PlateIntoRowProps) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      marginTop: 4,
      marginBottom: 4,
    }}
  >
    <div
      style={{
        flexGrow: 1,
      }}
    >
      {title}
    </div>
    <div style={{ fontSize: "20px" }}>:</div>
    <input
      style={{
        width: 336,
        minHeight: 24,
        marginLeft: 10,
        backgroundColor: "#E0E0E0",
        border: "1px solid #414042",
        paddingLeft: "5px",
      }}
      type="text"
      id={"input-field-" + title}
      value={value}
      readOnly
    />
  </div>
);

type Props = {
  plateAddress: PlateAddress;
  style?: React.CSSProperties;
};

export default function PlateInformationData({
  plateAddress,
  style = {},
}: Props) {
  const module = useTypedSelector(
    (state) => getModuleById(state)[plateAddress.moduleIdentifier]
  );
  const imagerModules = useTypedSelector(
    (state) => getModulesByType(state)[EModuleType.IMAGER]
  );
  const moduleStateById = useTypedSelector((state) =>
    getModuleStateById(state)
  );

  const plate = plateAddress.usedByPlate ?? plateAddress.reservedByPlate;

  if (plate == null) {
    return <div>No Plate Selected</div>;
  }

  let location = "-";

  if (module !== null && module !== undefined) {
    location = module.name;
  }

  if (plateAddress.usedByPlate == null) {
    for (const imagerModule of imagerModules) {
      const plateOnImager =
        moduleStateById[imagerModule.identifier].imager?.plate;
      if (plateOnImager?.barcode === plate.barcode) {
        location = imagerModule.name;
      }
    }
  }

  const dateDispensed = new Date(plate.dateDispensed);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        paddingRight: 38,
        paddingLeft: 51,
        fontSize: "14px",
        textAlign: "left",
        ...style,
      }}
    >
      <PlateInfoRow title="Project" value={plate.projectName} />
      <PlateInfoRow title="Experiment" value={plate.experimentName} />
      <PlateInfoRow
        title="Time Dispensed"
        value={
          isNaN(dateDispensed.getTime())
            ? "-"
            : DateUtil.toUsFormatString(dateDispensed)
        }
      />
      <PlateInfoRow title="Plate Type" value={plate.plateType.plateTypeName} />
      <PlateInfoRow title="Barcode" value={plate.barcode} />
      <PlateInfoRow title="Plate ID" value={plate.plateId} />
      <PlateInfoRow title="Location" value={location} />
      <PlateInfoRow title="User Name" value={plate.userName} />
    </div>
  );
}
